import React, { useRef, useState } from "react";
import { string, func } from "prop-types";
import debounce from "lodash.debounce";
import Icon from "../Icon/Icon.jsx";

const propTypes = {
  onTextChange: func.isRequired,
  placeholder: string,
  searchTerm: string,
};

const SimpleSearchBox = (props) => {
  const { onTextChange, placeholder, searchTerm } = props;

  const [inputValue, setInputValue] = useState(searchTerm || "");
  const [isDirty, setIsDirty] = useState(false);

  const handleInputChange = (e) => {
    // slash characters where crashing the Grants Search App.
    // "\\" is an escaped backslash
    if (inputRef.current.value === "/" || inputRef.current.value === "\\") {
      e.preventDefault();
      return false;
    }

    setInputValue(inputRef.current.value);
    setIsDirty(true);

    debounce(() => {
      onTextChange(inputRef.current.value);
    }, 500);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputRef.current.value === searchTerm || !isDirty) {
      return;
    }

    onTextChange(inputRef.current.value);
  };

  const inputRef = useRef();

  return (
    <div className="simple-search-box">
      <form
        className="simple-search-box__form"
        onSubmit={handleSubmit}
        role="search"
      >
        <input
          aria-label={placeholder}
          name="search"
          ref={inputRef}
          className="simple-search-box__input sc-form-item__field sc-form-item__field--search"
          type="search"
          placeholder={placeholder}
          value={inputValue}
          onChange={handleInputChange}
          onBlur={handleSubmit}
        />
        <button
          type="button"
          onClick={() => onTextChange(inputRef.current.value)}
          className="btn btn--primary simple-search-box__button"
          data-gtm-element="dcl search button"
        >
          <span>Search</span>
          <Icon iconName="search" className="icon--32x32" />
        </button>
      </form>
    </div>
  );
};

SimpleSearchBox.propTypes = propTypes;
export default SimpleSearchBox;
